import React from 'react';

import styles from './ProgressBar.module.scss';

const steps = {
  DESTINATION: 'Destination',
  DISTRIBUTION_METHOD: 'Distribution Method',
  FREQUENCY: 'Frequency',
  WITHHOLDING: 'Withholding',
  REVIEW: 'Review & Submit'
};

let StepCircle = ({ title, index, active, completed }) => {
  let circleStatus = '';
  if (active) circleStatus = 'active';
  if (completed) circleStatus = 'completed';

  return (
    <span className={`${styles.circle} ${styles[circleStatus]}`} key={index}>
      {!active ? '' : index}
    </span>
  );
};

const ProgressBar = ({ completedSteps = [], activeIndex = 0 }) => {
  const stepKeys = Object.keys(steps);
  return (
    <>
      <div className={styles['progress-bar']}>
        <div className={styles['progress-circles']}>
          {stepKeys.map((step, index) => {
            const completedStep = completedSteps.includes(index);
            return (
              <StepCircle
                key={index}
                title={steps[step]}
                index={index + 1}
                active={index === activeIndex}
                completed={completedStep}
              />
            );
          })}
        </div>
        <div className={styles['step-name']}>
          {steps[stepKeys[activeIndex]]}
        </div>
      </div>
    </>
  );
};

export default ProgressBar;
